document.addEventListener("DOMContentLoaded", function () {
  const variantSelectors = document.querySelectorAll('input[name="id"]');

  if (!variantSelectors.length) return;

  variantSelectors.forEach((selector) => {
    selector.addEventListener("change", function () {
      const selectedVariant = document.querySelector(
        'input[name="id"]:checked'
      ).value;

      fetch(`${window.location.pathname}?variant=${selectedVariant}`)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          // ✅ Update Hero Image
          const newHeroImage = doc.querySelector(
            `.slider-for div[data-variant-id="${selectedVariant}"] img`
          );
          if (newHeroImage) {
            const currentSlide = document.querySelector(
              ".slider-for .slick-current img"
            );
            if (currentSlide) {
              currentSlide.src = newHeroImage.src;
            }
          }

          // ✅ Update Price Badge
          const newPrice = doc.querySelector(".current-priceap")?.innerText;
          const newComparePrice =
            doc.querySelector(".compare-priceap")?.innerText;
          const newDiscountBadge =
            doc.querySelector(".discount-badgeap")?.innerText;

          document.querySelector(".current-priceap").innerText = newPrice || "";
          document.querySelector(".compare-priceap").innerText =
            newComparePrice || "";

          const discountBadgeElement =
            document.querySelector(".discount-badgeap");
          if (newDiscountBadge) {
            discountBadgeElement.innerText = newDiscountBadge;
            discountBadgeElement.style.display = "inline-block"; // Show if available
          } else {
            discountBadgeElement.style.display = "none"; // Hide if no discount
          }

          // ✅ Update URL
          window.history.replaceState({}, "", `?variant=${selectedVariant}`);
        })
        .catch((error) => console.error("Variant switching error:", error));
    });
  });
});
